<div class="modal-header">
    <h4 class="modal-title pull-left">{{delayBlockData['title']}}</h4>
</div>
<div class="modal-body cs-common-ui">
    <form class="no-form-style" *ngIf="form" [formGroup]="form" novalidate>
        <div class="cs-d-flex flex-column">
            <div class="cs-helper-section bg-white cs-border cs-border--bottom">
                <div class="cs-help-text-color p--15">{{delayBlockData['description']}}</div>
            </div>

            <app-conditional-edge2
                *ngIf="isConditional"
                [dagSourceModel]="dagSourceModel"
                [blockObject]="blockObject"
                [conditionalColName]="conditionalColName"
                [form]="form">
            </app-conditional-edge2>

            <div class="cs-flex-1">
                <div class="cs-block-widget--form cs-d-flex flex-column">
                    <div class="cs-block-widget--form-control">
                        <label class="control-label required_field mr-auto">{{delayBlockData['inputLabelText']}}:</label>
                        <div class="cs-d-flex">
                            <ng-container [ngSwitch]="form.get('unit').value">
                                <select *ngSwitchCase="'Minutes'" class="full-width-select mr-10" formControlName="interval">
                                    <option *ngFor="let interval of minutesInterval" value="{{interval}}">{{interval}}</option>
                                </select>
                                <select *ngSwitchCase="'Hours'" class="full-width-select mr-10" formControlName="interval">
                                    <option *ngFor="let interval of hoursInterval" value="{{interval}}">{{interval}}</option>
                                </select>
                                <select *ngSwitchCase="'Days'" class="full-width-select mr-10" formControlName="interval">
                                    <option *ngFor="let interval of daysInterval" value="{{interval}}">{{interval}}</option>
                                </select>
                                <select *ngSwitchCase="'Months'" class="full-width-select mr-10" formControlName="interval">
                                    <option *ngFor="let interval of monthsInterval" value="{{interval}}">{{interval}}</option>
                                </select>
                            </ng-container>
                            <select class="full-width-select" formControlName="unit" (change)="onChangeUnit($event)">
                                <option *ngFor="let unit of units" value="{{unit}}">{{unit}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </form>
</div>
<div class="modal-footer">
    <ng-container *ngIf="form else footerSection">
        <button *ngIf="showDeleteBtn" class="btn btn-danger btn-medium float-left" (click)="remove()" type="button">Delete </button>
        <button class="btn btn-link" (click)="closeModal()">Cancel</button>
        <button type="submit" class="btn btn-primary" [disabled]="!form.valid || isFormSubmitted" (click)="save()">
            <span *ngIf="!isFormSubmitted" translate>Save</span>
            <span *ngIf="isFormSubmitted" translate>Saving</span>
        </button>
    </ng-container>
</div>

<ng-template #footerSection>
    <button class="btn btn-link" [disabled]="true">Cancel</button>
    <button type="submit" class="btn btn-primary" [disabled]="true">
        <span translate>Save</span>
    </button>
</ng-template>
